// extracted by mini-css-extract-plugin
module.exports = {"text":"CMSSectionElement_text__y8T7C","cmsItem":"CMSSectionElement_cmsItem__1ATbh","title":"CMSSectionElement_title__2EN6y","mediaSection":"CMSSectionElement_mediaSection__3V-ya"};